// extracted by mini-css-extract-plugin
export default {"extendBtn":"_3XU8y7KTp6_Pr-wUrZsNKA"};